import app from '@/app';

const component = {
	templateUrl: '/app/admin/user/user-detail.html',
	controller: Controller,
	bindings: {
		$transition$: '<',
		entity: '<',
		allTimezones: '<'
	}
};

/* @ngInject */
function Controller($controller, $translate, User, Role, LANGUAGES, Principal) {
	$controller('AbstractEntityDetailController', { $ctrl: this, resource: User, type: 'user' });
	var $ctrl = this;
	$ctrl.languages = LANGUAGES;

	$ctrl.currentAccount = null;

	Principal.identity().then(account => {
		$ctrl.currentAccount = account;
	});

	$ctrl.$onInit = () => {
		$ctrl.queryRoles();
		if ($ctrl.entity && $ctrl.entity.roles && $ctrl.entity.roles.length > 0) {
			$ctrl.selectedRole = $ctrl.entity.roles[0];
		}
	};

	$ctrl.onRoleChange = item => {
		$ctrl.entity.roles = [item];
	};

	var transition = $ctrl.transition;
	$ctrl.transition = function(params) {
		$ctrl.entity.timezone = 'America/Sao_Paulo';
		$ctrl.entity.language = 'pt-br';
	};

	$ctrl.queryRoles = query => {
		$ctrl.allRoles = [
			{ id: 2, name: $translate.instant('user.administrator') },
			{ id: 3, name: $translate.instant('user.analysis') },
			{ id: 4, name: $translate.instant('user.agency') },
			{ id: 5, name: $translate.instant('user.dataLoad') },
			{ id: 6, name: $translate.instant('user.dataQuery') }
		];
		if (query) {
			return Role.query(
				{ query: query, page: 0, size: 15, sort: 'name,asc' },
				data => ($ctrl.allRoles = data.content)
			).$promise;
		}
	};
}

app.component('userDetail', component);
